/* Misty Lorette unified product and page size-guide behaviour. */
(() => {
  const sizeMap = {
    S: { AU: 'AU 8–10', UK: 'UK 8–10', US: 'US 4–6', EU: 'EU 36–38' },
    M: { AU: 'AU 10–12', UK: 'UK 10–12', US: 'US 6–8', EU: 'EU 38–40' },
    L: { AU: 'AU 12–14', UK: 'UK 12–14', US: 'US 8–10', EU: 'EU 40–42' },
  };

  const setRegion = (root, region) => {
    root.querySelectorAll('[data-region]').forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.region === region ? 'true' : 'false');
    });

    root.querySelectorAll('.szR[data-size]').forEach((size) => {
      size.textContent = sizeMap[size.dataset.size]?.[region] || '';
    });

    root.querySelectorAll('[data-col]').forEach((cell) => {
      const isActive = cell.dataset.col === region;
      cell.style.color = isActive ? '#C7AB7C' : '';
      cell.style.fontWeight = isActive ? '600' : '';
    });
  };

  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-ml-size-guide]').forEach((root) => {
      if (root.dataset.mlSizeGuideReady === 'true') return;
      root.dataset.mlSizeGuideReady = 'true';
      setRegion(root, 'AU');
    });
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-mlsg-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (dialog?.showModal) dialog.showModal();
      return;
    }

    const regionButton = event.target.closest('[data-ml-size-guide] [data-region]');
    if (regionButton) {
      const root = regionButton.closest('[data-ml-size-guide]');
      setRegion(root, regionButton.dataset.region);
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.matches('dialog.mlsg')) event.target.close();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
